// noinspection JSVoidFunctionReturnValueUsed

jQuery(function ($) { // wait for document ready
    var headerHeight = $('.page-header').outerHeight();
    var adminBarHeight = 0;
    if ($('#wpadminbar').length) {
        headerHeight += $('#wpadminbar').outerHeight();
        adminBarHeight += $('#wpadminbar').outerHeight();
    }
    var controller = new ScrollMagic.Controller({});
    var scenes = [];
    var doit;
    window.onresize = function () {
        clearTimeout(doit);
        doit = setTimeout(scrollSetup, 100);
    };
    setupCharitableTrustsPage();
    var curSize = '';

    function setupCharitableTrustsPage(force = false) {
        var windowWidth = $(window).width();
        var newSize = 'desktop';
        if (windowWidth <= 767) {
            newSize = 'mobile';
        }
        if (curSize == newSize && !force)
            return true;

        curSize = newSize;
        resetScrollMagic();
        var cookieVal = read_cookie('notice-dismissed');
        if (curSize == 'mobile') {

        } else if (curSize == 'desktop') {
            var slides;
            if ($('.offshore-trust-page').length) { // on either parent page or child page, set the animation for the cookie notice
                if (cookieVal != 'dismissed') {
                    scenes.push(new ScrollMagic.Scene({triggerElement: "#slide1"})
                        // trigger animation by adding a css class
                        .setClassToggle($('.cta-floating')[0], "visible")
                        .addTo(controller));
                } else {
                    delete_cookie('notice-dismissed');
                }
            }
            if ($('.offshore-trust-page').length) { // child page
                console.log('child page');
                // pin slide 1 throughout slides 2 and 3, so the heading stays still while the first 3 messages with the
                // white backgrounds scroll in and fade out
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide1',
                        duration: "185%",
                        offset: -1 * headerHeight
                    })
                        // .setPin('#slide1', {pushFollowers: false})
                        //                         .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                // toggle the active class to fade the text with the white background to fade in/out for slide 1
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onEnter',
                        triggerElement: '#slide1',
                        duration: "185%",
                        offset: -1 * headerHeight
                    })
                        .setClassToggle($('#slide1')[0], "active")
                        // .addIndicators({name: 'Slide 1 Class'}) // add indicators (requires plugin)
                        .addTo(controller)
                );

          
                const slides = ['slide4', 'slide5'];

                slides.forEach((slide, index) => {
                    // Class Toggle Scene
                    const sceneOptions = {
                        triggerElement: `#${slide}`,
                        offset: -1 * (headerHeight),
                        triggerHook: 0.2, // Earlier trigger point
                        duration: slide === 'slide5' ? '70%' : '80%' // Adjust durations
                    };

                    const classToggleScene = new ScrollMagic.Scene(sceneOptions)
                        .setClassToggle(document.getElementById(slide), 'active')
                        // .addIndicators({ name: `${slide} Class Toggle` }) // Uncomment for debugging
                        .addTo(controller);

                    scenes.push(classToggleScene);

                    // Pinning Scene for Slides
                    const pinOptions = {
                        triggerElement: `#${slide}`,
                        triggerHook: slide === 'slide5' ? 0.3 : 0.2, //', // Earlier trigger point
                        duration: slide === 'slide5' ? '100%' : '300%', // Adjust durations
                        offset: 0 * (headerHeight),

                    };

                    const pinSettings = {
                        pushFollowers: slide === 'slide5' ? true : false
                    };

                    const pinScene = new ScrollMagic.Scene(pinOptions)
                        .setPin(`#${slide}`, pinSettings)
                        // .addIndicators({ name: `${slide} Pin` }) // Uncomment for debugging
                        .addTo(controller);

                    scenes.push(pinScene);
                });


                /*** WATER MILL BACKGROUND ***/

                const backgroundPinScene = new ScrollMagic.Scene({
                    triggerElement: '#slide4', // Start pinning at slide4
                    triggerHook: 0, // When slide4 reaches the top
                    duration: $('#slide4').outerHeight(true) + $('#slide5').outerHeight(true) // Total height of slide4 and slide5
                })
                    .setPin('#background-wrap', { pushFollowers: false })
                    // .addIndicators({ name: 'Background Pin' }) // Uncomment for debugging
                    .addTo(controller);

                scenes.push(backgroundPinScene);


                /*** END OF WATER MILL BACKGROUND **/

                // this pins slide 9 (the plain blue background) so it stays in the same place for a moment while scrolling
                // CIOS / Grant making foundations



                var background = $('#bg-3')[0]
                // // add animations for the background to slide across and back as we scroll
          

                // // set up the background to slide in when reaching the element with the background (top of slide 6)
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: background,
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: 0
                })
                   // .setTween(backgroundSlideIn)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // // slide 6 also has the text and box sliding in from the left and right
            

               var slideBoxFromRightTween2 = gsap.timeline()
               .fromTo($("#slide6").find('.box')[0], 
                   { x: "-100vw", opacity: 0 },  // Start fully off-screen to the right
                   { x: "0", left: "0", opacity: 1, duration: 0.7, ease: "power2.out" } // Move to the center
               );

               var slideBoxFromLeftTween2 = new TimelineMax()
               .fromTo($("#slide6").find('.second-box')[0],
                   { x: "100vw", opacity: 0 },  // Start fully off-screen to the left
                   { x: "0", right: "0", opacity: 1, duration: 0.7, ease: "power2.out" } // Move to the center
               )
           

            

             // make the box slide in from the right when entering slide 6
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: background,
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: 0
                })
                    .setTween(slideBoxFromRightTween2)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                    scenes.push(new ScrollMagic.Scene({
                        triggerElement: background,
                        offset: -1 * (headerHeight),
                        triggerHook: 0.75,
                        duration: 0
                    })
                        .setTween(slideBoxFromLeftTween2)
                        // .addIndicators() // add indicators (requires plugin)
                        .addTo(controller));

              

                // // make the background slide back when entering slide 8
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide8',
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: '50%'
                })
                   // .setTween(backgroundSlideBack)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // // // slide 8 is the same as slide 6, with the text and boxes sliding in from the left and right
                          
                var slideTextFromLeftTween3 = new TimelineMax()
                    .from($("#slide8").find('h2')[0], 0.5, {
                        css: { opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide8").find('h2')[0], 0.5, {
                        css: {opacity: 1},
                        ease: Linear.easeInOut
                    });

                var slideBoxFromRightTween3 = new TimelineMax()
                    .from($("#slide8").find('#slide-8-box-2')[0], 0.7, {
                        css: {'left': '50vw', top: 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide8").find('#slide-8-box-2')[0], 0.5, {
                        css: {'left': 0, top: 0, opacity: 1},
                        ease: Linear.easeInOut
                    });

                    var slideBoxFromLeftTween3 = new TimelineMax()
                    .from($("#slide8").find('#slide-8-box-1')[0], 0.7, {
                        css: {'left': '-100%', top: 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    // .to($("#slide8").find('#slide-8-box-1')[0], 0.5, {
                    //     css: {'left': '-25%', top: 0, opacity: 1},
                    //     ease: Linear.easeInOut
                    // });

                // // // make the text slide in from the left when entering slide 8
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: "#slide8",
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: '0'
                })
                    .setTween(slideTextFromLeftTween3)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // // // make the box slide in from the right when entering slide 8
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: "#slide8",
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: '0'
                })
                    .setTween(slideBoxFromRightTween3)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                    scenes.push(new ScrollMagic.Scene({
                        triggerElement: "#slide8",
                        offset: -1 * (headerHeight),
                        triggerHook: 0.75,
                        duration: '0'
                    })
                        .setTween(slideBoxFromLeftTween3)
                        // .addIndicators() // add indicators (requires plugin)
                        .addTo(controller));

                // // this pins the background for slides 6 - 8 so it stays at the same vertical position through these slides
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#background3-wrap',
                    offset: -1 * (headerHeight),
                    triggerHook: 'onLeave',
                    duration: '580%'
                })
                    .setPin('#background3-wrap', {pushFollowers: false})
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // // this pins slide 6 so it stays in the same place for a moment while scrolling
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: '#slide6',
                    duration: "75%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide6', {pushFollowers: true})
                    // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                    .addTo(controller));

           

                // // this pins slide 8 so it stays in the same place for a moment while scrolling
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: '#slide8',
                    duration: "75%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide8', {pushFollowers: true})
                    // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                    .addTo(controller));


                

                // make the divider slide out from the top when entering slide 10
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: "#slide10",
                    offset: -1 * (headerHeight),
                    triggerHook: 0.25,
                    duration: '50%'
                })
                    .setTween(slideOutBorder)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));
            
            

            };


       
        }
    }

    // Reset all scenes and controller
    function resetScrollMagic() {
        if (controller)
            controller.destroy('reset');
        controller = null;
        $.each(scenes, function (k, scene) {
            if (scenes[k])
                scenes[k].destroy('reset');
            scenes[k] = null;
        });
        scenes = [];
        controller = new ScrollMagic.Controller({});
    }

 
    window.onpopstate = function (e) {
        if (e.state) {
            $(e.state.targetElement).html(e.state.html);
            document.title = e.state.pageTitle;
        } else {
            $('[data-action="load-inline"]').each(function () {
                $($(this).data('target')).html('');
            });
        }
    };
});